import type { WritableComputedRef } from 'vue'

import { useDisciplineProgressReportsStore } from './progress-reports/store'
import { useDisciplineFiltersDraft } from './discipline-filters-draft.hook'
import { disciplineProgressReportsFiltersToQuery } from '../lib/discipline-progress-reports-query'
import { fromTutorTasksDateRange, toTutorTasksDateRange } from '../lib/tutor-tasks-query'

interface FiltersDisciplineProgressReportsReturn {
  refDueDateRange: WritableComputedRef<Date[] | null>
  isLoading: ComputedRef<boolean>
  search: () => void
  clearFilters: () => void
}

export const useFiltersDisciplineProgressReports = (): FiltersDisciplineProgressReportsReturn => {
  const store = useDisciplineProgressReportsStore()

  const { refDraft, isLoading, patchDraft, search, clearFilters } = useDisciplineFiltersDraft({
    applied: () => store.getFilters,
    onApply: filters => store.setFilters(filters),
    onReset: () => store.resetFilters(),
    toQuery: disciplineProgressReportsFiltersToQuery,
    loading: () => store.isLoading,
  })

  /** The same due-date bounds as the Tasks tab, so its range converters apply as they are. */
  const refDueDateRange = computed<Date[] | null>({
    get: () => toTutorTasksDateRange(refDraft.value.dueDateFrom, refDraft.value.dueDateTo),
    set: (value) => {
      patchDraft(fromTutorTasksDateRange(value))
    },
  })

  return {
    refDueDateRange,
    isLoading,
    search,
    clearFilters,
  }
}
